import styled, { css } from 'styled-components';
import {
  borderDangerBase,
  helpTextDanger,
  helpTextDefault,
  inputBorderRest,
} from 'styles/variables';
import { placeholderTextDefault } from 'styles/variables/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  width: 100%;
`;

interface SelectContainerProps {
  hasError?: boolean;
}

export const SelectContainer: React.FC<SelectContainerProps> =
  styled.button<SelectContainerProps>`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    box-shadow: none;
    border: 1px solid
      ${({ hasError }) => (hasError ? borderDangerBase : inputBorderRest)};
    height: 40px;
    &::placeholder {
      color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
    }
    background-color: #ffffff;
    position: relative;
    color: ${({ theme }) => theme.configs.mainBox.bgColor};
    font-family: inherit;
  ` as any;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const SelectLabel = styled.label`
  align-items: center;
  display: grid;
  flex: 1;
  flex-wrap: wrap;
  overflow: hidden;
  padding: 2px 8px;
  box-sizing: border-box;
  color: rgb(51, 51, 51);
  margin: 0;
`;

export const SelectValue = styled.span<{ isPlaceholder?: boolean }>`
  font-size: 14px;
  flex-wrap: wrap;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ isPlaceholder }) =>
    isPlaceholder &&
    css`
      color: ${placeholderTextDefault};
    `}
`;

export const SelectToggleButton = styled.div<{ disabled?: boolean }>`
  all: unset;
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 2px 6px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  background-color: transparent;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
    `}
`;

export const SelectMenu = styled.ul<{ isOpen?: boolean }>`
  all: unset;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  margin-top: 4px;
  background-color: ${({ theme }) => theme.configs.tertiaryBox.bgColor};
  border: 1px solid ${inputBorderRest};
  border-radius: 8px;
  box-shadow: 0 0 10px 0
    ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: none;
    `}
`;

export const SelectItem = styled.li<{
  isHighlighted?: boolean;
  isSelected?: boolean;
}>`
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
  display: flex;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
    `}

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: ${({ theme }) => theme.configs.mainBox.bgColor};
      color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
    `}
`;

export const SelectNoResults = styled.div`
  display: block;
  padding: 12px 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
  text-align: center;
`;

export const SelectHelperText = styled.div<{
  isError?: boolean;
  size?: 'sm' | 'lg' | 'md';
}>`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 2px 6px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  color: ${({ isError }) => {
    if (isError) {
      return helpTextDanger;
    }

    return helpTextDefault;
  }};

  ${({ size }): string => {
    switch (size) {
      case 'sm':
        return `
          font-size: 10px;
          line-height: 15px;
        `;
      case 'lg':
        return `
          font-size: 16px;
          line-height: 21px;
        `;
      case 'md':
      default:
        return `
          font-size: 14px;
          line-height: 1.5;
        `;
    }
  }}
`;
